import { render } from "./Taxes.vue?vue&type=template&id=78d8b4e2&ts=true"
import script from "./Taxes.vue?vue&type=script&lang=ts"
export * from "./Taxes.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__